import React, { PureComponent } from 'react';
import styled from 'styled-components';
import HomeLayout from '../../components/HomeLayout';
import viFetchAdapter from '../../viFetchAdapter';
import CubeSpiner from '../../components/spiners/CubeSpiner';

const Content = styled.div`
  color: white;
`;

class Section extends PureComponent {
  state = {
    content: '',
    isLoading: true,
  }

  componentDidMount() {
    this.initialize(this.props.match.params.permalink);
  }

  componentWillReceiveProps(nextProps) {
    this.initialize(nextProps.match.params.permalink)
  }

  initialize = (permalink) => {
    const match = permalink.match(/^.*-([0-9]*).html$/);
    const sectionId = match[1];
    this.loadContent(sectionId);
  }

  loadContent = async (sectionId) => {
    const { data } = await viFetchAdapter.get(`/api/sections/getContent?id=${sectionId}`);
    this.setState({
      isLoading: false,
      content: data,
    });
  }

  render() {
    return (
      <HomeLayout>
        {this.state.isLoading && <CubeSpiner width="200" height="200" />}
        {!this.state.isLoading && <Content dangerouslySetInnerHTML={{ __html: this.state.content }} />}
      </HomeLayout>
    );
  }
}

export default Section;



// WEBPACK FOOTER //
// ./src/routes/Section/index.js